import { render, staticRenderFns } from "./speedDialDettaglio.vue?vue&type=template&id=1a544eb9"
import script from "./speedDialDettaglio.vue?vue&type=script&lang=js"
export * from "./speedDialDettaglio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports